import { DragEvent } from 'react';
import {
  DragAndDropContextState,
  getDragImageOffset,
  isTargetDragHandleButton,
} from '@ardoq/drag-and-drop';
const perspectivesRowDragAndDropHandlers = (
  rowId: string | null,
  { setDraggedCardId, setDraggedOverCard, resetState }: DragAndDropContextState
) => {
  const onDragOver = (e: DragEvent<HTMLDivElement>) => {
    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
    const middleOfRect = rect.top + rect.height / 2;
    const position = middleOfRect > e.clientY ? 'before' : 'after';
    setDraggedOverCard(rowId, position);
  };

  const onDragEnd = () => {
    resetState();
  };
  const onDragStart = (event: DragEvent<HTMLDivElement>) => {
    // allow dragging only by button, but display entire rule when dragged
    if (!isTargetDragHandleButton(event.target)) {
      return;
    }
    const { offsetX, offsetY } = getDragImageOffset(
      event.currentTarget.getBoundingClientRect(),
      event.clientX,
      event.clientY
    );
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setDragImage(event.currentTarget, offsetX, offsetY);
    setDraggedCardId(rowId || null);
  };
  return { onDragOver, onDragEnd, onDragStart };
};
export { perspectivesRowDragAndDropHandlers };
